var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sp-video"},[_c('video',{attrs:{"src":require(`~/assets/video/splash-${
        Math.floor(Math.random() * 2) + 1
      }.mp4`),"autoplay":"","muted":"","playsinline":"","loop":""},domProps:{"muted":true}}),_vm._v(" "),_c('div',{staticClass:"sp-video-gradient"})])
}
var staticRenderFns = []

export { render, staticRenderFns }